import React from 'react';

const AccessError = ({ error }) => (
  <div className="access-error">{error}</div>
);

export default React.memo(AccessError);
